export default __webpack_public_path__ + "static/media/angle-small-left.25e0c1c3.svg";